import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { CloseIcon } from '@beef/ui-kit';

import { setFiltersBarClose } from 'store/ProductCatalog/controls/actions';
import { resetAllOptions } from 'store/ProductCatalog/filters/actions';
import {
  getIsCatalogAnyFilterChanged,
  getAllFiltersActiveOptionsCount,
} from 'store/ProductCatalog/filters/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const SidebarHeader = ({
  isMobile,
  isTablet,
  className,
  onReset,
  isAnyFilterChanged,
  filtersCount,
  onClick,
}) => (
  <div className={cx('component', { mobile: isMobile }, { tablet: isTablet }, className)}>
    {isTablet || isMobile ?
      <div className={cx('wrapper')}>
        {isAnyFilterChanged && (
          <div
            className={cx('clear', 'clearTablet', isMobile ? 'clearMobile' : '')}
            onClick={onReset}
            role="button"
            tabIndex={0}
          >
            Сбросить фильтры
          </div>
        )}
        <div className={cx('title')}>Фильтры</div>
        <div role="button" tabIndex={0} onClick={onClick} className={cx('close')}>
          <CloseIcon size="s" className={cx('closeIcon')} />
        </div>
      </div>
    : null}
    {!isTablet && !isMobile ?
      <div className={cx('wrapper')}>
        <div className={cx('title')}>
          Фильтры
          {filtersCount ?
            <div className={cx('badge')}>{filtersCount}</div>
          : null}
        </div>
        {isAnyFilterChanged && (
          <div className={cx('clear')} onClick={onReset} role="button" tabIndex={0}>
            Сбросить фильтры
            <CloseIcon size="s" className={cx('icon')} />
          </div>
        )}
      </div>
    : null}
  </div>
);

SidebarHeader.propTypes = {
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  className: PropTypes.string,
  onReset: PropTypes.func,
  isAnyFilterChanged: PropTypes.bool,
  filtersCount: PropTypes.number,
  onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isAnyFilterChanged: getIsCatalogAnyFilterChanged(state),
  filtersCount: getAllFiltersActiveOptionsCount(state),
});

const mapDispatchToProps = {
  onClick: setFiltersBarClose,
  onReset: resetAllOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarHeader);
